import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneField from "../../common/input/PhoneField";
import bkstApi from "../../api";
import { isPhoneValid, isEmailValid } from "../../common/util";
import EmailInput from "../../common/component/EmailInput";

export default function SendReceipt(props) {
  const { orderId, paymentIntentId } = props;

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("sms");
  const [email, setEmail] = useState(props.email || "");
  const [phone, setPhone] = useState(props.phone || "");
  const [errors, setErrors] = useState([]);

  const validate = () => {
    let arr = [];

    if (mode === "sms") {
      if (!isPhoneValid(phone)) {
        arr.push("Invalid Phone Number");
      }
    } else if (mode === "email") {
      if (!isEmailValid(email)) {
        arr.push("Invalid email");
      }
    }

    return arr;
  };

  const sendReceipt = () => {
    let arr = validate();
    setErrors(arr);
    if (arr.length > 0) {
      return;
    } else {
      bkstApi
        .post(`/my/receipt`, { orderId, paymentIntentId, mode, email, phone })
        .then((res) => {
          setOpen(false);
        })
        .catch((err) => {
          setErrors([err.response?.data?.msg]);
        });
    }
  };

  let style = props.disabled ? { pointerEvents: "none", cursor: "not-allowed" } : {};
  if (props.fullWidth) {
    style = { ...style, width: "100%", display: "block" };
  }

  return (
    <>
      <span
        onClick={
          props.disabled
            ? undefined
            : () => {
                setMode(props.mode);
                setEmail(props.email || "");
                setPhone(props.phone || "");
                setOpen(true);
              }
        }
        style={style}
        aria-disabled={props.disabled ? "true" : undefined}
      >
        {props.children}
      </span>
      {open && (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true} maxWidth="xs">
          <DialogTitle>
            Send Receipt
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box pt={4} pb={2}>
              {mode === "email" && <EmailInput value={email} onChange={(val) => setEmail(val)} />}
              {mode === "sms" && <PhoneField value={phone} onChange={(val) => setPhone(val)} />}
            </Box>
            {errors.length > 0 && (
              <Alert sx={{ justifyContent: "center" }} severity="error">
                {errors.join(". ")}
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button color="secondary" variant="contained" onClick={() => setOpen(false)} fullWidth>
              Cancel
            </Button>
            <Button color="primary" variant="contained" onClick={sendReceipt} fullWidth>
              SEND
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
